export const vagasEnum = {
	0: "IDENTIFICACAO_EMPREGADOR",
	1: "DADOS_VAGA",
	2: "REQUISITOS",
	3: "DADOS_ENTREVISTA",
}

export const vagasEnumCod = {
	"IDENTIFICACAO_EMPREGADOR": 0,
	"DADOS_VAGA": 1,
	"REQUISITOS": 2,
	"DADOS_ENTREVISTA": 3,
}
